__webpack_require__.p = "/EDIYACOFFEE/";